<div class="mx-auto avatar-container">
  <div class='h-100 w-100 d-flex align-items-center justify-content-between avatar'>
    <div class='mx-auto avatar-text' [ngStyle]="{ 'font-size': fontSize }">{{ initials }}</div>
  </div>
</div>